import { Expose, Type } from 'class-transformer'
import SimpleStoreProduct from '@/calendesk/models/DTO/Response/SimpleStoreProduct'

export default class SimpleStoreProductTransaction {
  public id!: number

  @Expose({ name: 'provider_tag' })
  public providerTag!: string

  @Expose({ name: 'transaction_id' })
  public transactionId!: string

  @Expose({ name: 'fakturownia_invoice_id' })
  public fakturowniaInvoiceId!: string

  @Expose({ name: 'invoice_number' })
  public invoiceNumber!: string

  public status!: string

  @Expose({ name: 'paid_at' })
  public paidAt!: string

  public price!: number

  @Type(() => SimpleStoreProduct)
  public product!: SimpleStoreProduct
}
